import { RootState } from 'app/store'

import { IContinuousRoute } from '$/types'

import { ILocalFilter, RiskUnitType } from '.'

export const selectRiskUnit = (state: RootState): RiskUnitType =>
  state.localFilter.riskUnit

export const showRiskDensity = (state: RootState): boolean =>
  state.localFilter.showRiskDensity

export const selectSavedFilter = (state: RootState): ILocalFilter =>
  state.localFilter.savedFilter

export const selectPreviousSegments = (
  state: RootState
): IContinuousRoute[] | undefined => state.localFilter.previousSegments
